module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/logo-small-30df97bec12f1f3b48555a609b48f906.png";